module.exports = __webpack_public_path__ + "img/teaser_240x200_richykochheader.4d1264a4.jpg";